import Vue from 'vue';
import Vuex from 'vuex';
import 'whatwg-fetch';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';
import { getAdresseringFromVejkodeObjekt } from '@/util';
import { fitToGeoDkLayerExtent } from '@/openLayersMap/util';
import { geodkVectorSelected } from '@/openLayersMap/Layers';
import DawaApi from '@/api/Dawa';
import GeoDkApi from '@/api/GeoDanmark';
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user: null,
    kommune: localStorage.getItem('kommune')
      ? JSON.parse(localStorage.getItem('kommune'))
      : { kode: '0657', navn: 'Herning' },
    map: null,
    center: [562087.95, 6329837.31],
    zoom: 7,
    useKommuneBBox: true,
    geoDkObjekter: [],
    fetchedVejkoder: {},
    vejkodeAdressePunkter: {},
    loading: true,
    opgaver: {
      nye: [
        {
          id: 1,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Hovedrute bør have vejkode. Forslag: (1449) Messemotorvejen',
          vejkode: 1449,
          geodkobjekter: [
            1112865417,
            1112865425,
          ],
        },
        {
          id: 2,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Til- og frakørsel bør have vejkode. Forslag: (1449) Messemotorvejen',
          vejkode: 1449,
          geodkobjekter: [
            1112865880,
          ],
        },
        {
          id: 3,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Til- og frakørsel bør have vejkode. Forslag: (1517) Holstebromotorvejen',
          vejkode: 1517,
          geodkobjekter: [
            1113229276,
            1112865595,
          ],
        },
        {
          id: 4,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Rundkørsel bør have vejkode. Forslag: (7385) Snejbjergvej',
          vejkode: 7385,
          geodkobjekter: [
            1113226394,
            1113226870,
          ],
        },
        {
          id: 5,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Rundkørsel bør have vejkode. Forslag: (3630) Jens Mathiasens Vej',
          vejkode: 3630,
          geodkobjekter: [
            1114636919,
            1114636870,
            1114636870,
          ],
        },
        {
          id: 6,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Mellem vej bør have vejkode. Forslag: (6970) Skalmejevej',
          vejkode: 6970,
          geodkobjekter: [
            1114636876,
          ],
        },
        {
          id: 7,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Mellem vej bør have vejkode. Forslag: (2995) Hjejlevej',
          vejkode: 2995,
          geodkobjekter: [
            1114636872,
            1114636884,
            1114636898,
          ],
        },
        {
          id: 8,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Mellem vej bør have vejkode. Forslag: (1447) Logistikvej',
          vejkode: 1447,
          geodkobjekter: [
            1114636916,
            1114636868,
            1114636902,
          ],
        },
        {
          id: 9,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Mellem vej bør have vejkode. Forslag: (6970) Skalmejevej',
          vejkode: 6970,
          geodkobjekter: [
            1114636927,
          ],
        },
        {
          id: 10,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Mellem vej bør have vejkode. Forslag: (4955) Løvbakkevej',
          vejkode: 4955,
          geodkobjekter: [
            1114636935,
          ],
        },
        {
          id: 11,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Mellem vej bør have vejkode. Intet forslag',
          geodkobjekter: [
            1114636879,
            1114636937,
            1114636896,
          ],
        },
        {
          id: 12,
          titel: 'Nyt vejnavn uden vej',
          beskrivelse: 'Nyt vejnavn (1525) Søhaven findes ikke i GeoDanmark',
          vejkode: 1525,
          bbox: [500620, 6229450, 500800, 6229750],
        },
        {
          id: 13,
          titel: 'Nyt vejnavn uden vej',
          beskrivelse: 'Nyt vejnavn (1528) Gartnerparken findes ikke i GeoDanmark',
          vejkode: 1528,
          bbox: [485500, 6228366, 485650, 6228399],
        },
        {
          id: 14,
          titel: 'Sti uden vejkode',
          beskrivelse: 'Hovedsti langs vej bør have vejkode. Forslag: (2680) Hammerum Hovedgade',
          vejkode: 2680,
          geodkobjekter: [
            1076756841,
          ],
        },
        {
          id: 15,
          titel: 'Sti uden vejkode',
          beskrivelse: 'Hovedsti langs vej bør have vejkode. Forslag: (2680) Hammerum Hovedgade',
          vejkode: 2680,
          geodkobjekter: [
            1076756441,
          ],
        },
        {
          id: 16,
          titel: 'Sti uden vejkode',
          beskrivelse: 'Hovedsti langs vej bør have vejkode. Forslag: (6897) Silkeborgvej',
          vejkode: 6897,
          geodkobjekter: [
            1076757985,
          ],
        },
        {
          id: 17,
          titel: 'Sti uden vejkode',
          beskrivelse: 'Hovedsti langs vej bør have vejkode. Forslag: (6897) Silkeborgvej',
          vejkode: 6897,
          geodkobjekter: [
            1076758783,
          ],
        },
        {
          id: 18,
          titel: 'Sti med forkert vejkode',
          beskrivelse: 'Sti langs vej har anden vejkode end vejen. Forslag: (1806) Fredensgade',
          vejkode: 1806,
          geodkobjekter: [
            1076759325,
            1076757315,
          ],
        },
        {
          id: 19,
          titel: 'Sti med forkert vejkode',
          beskrivelse: 'Sti langs vej har anden vejkode end vejen. Forslag: (1806) Fredensgade',
          vejkode: 1806,
          geodkobjekter: [
            1076754711,
            1076755913,
          ],
        },
        {
          id: 20,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Lille vej bør have vejkode. Forslag: (0587) Langgade',
          vejkode: 587,
          geodkobjekter: [
            1113212148,
          ],
        },
        {
          id: 21,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Lille vej bør have vejkode. Forslag: (3403) Højgårdvænget',
          vejkode: 3403,
          geodkobjekter: [
            1113220813,
          ],
        },
        {
          id: 22,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Lille vej bør have vejkode. Forslag: (0861) Rugbjergvej',
          vejkode: 861,
          geodkobjekter: [
            1113221891,
          ],
        },
        {
          id: 23,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Adgangsvej bør have vejkode; formentlig (1280) Vildbjergvej',
          vejkode: 1280,
          geodkobjekter: [
            1113199548,
          ],
        },
        {
          id: 24,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Adgangsvej bør have vejkode. Forslag: (1019) Spåbækvej',
          vejkode: 1019,
          geodkobjekter: [
            1113213284,
            1076777802,
            1076829230,
            1076818440,
          ],
        },
        {
          id: 25,
          titel: 'Vej uden vejkode',
          beskrivelse: 'Adgangsvej bør have vejkode. Forslag: (0483) Ilderhedevej',
          vejkode: 483,
          geodkobjekter: [
            1076798731,
          ],
        },
      ],
      sendt: [

        {
          id: 0,
          titel: 'Sæt vejkode for objekter',
          beskrivelse: 'Sæt ny vejkode for liste med objekter.',
          vejkode: 6448,
          geodkobjekter: [
            1105082327,
            1105082572,
            1105082014,
            1105081504,
          ],
        },
        {
          id: 1,
          titel: 'Tjek ud område',
          beskrivelse: 'Se om ting ser godt ud i denne bbox.',
          bbox: [562000, 6322000, 564000, 6324000],
        },
        {
          id: 2,
          titel: 'Tjek ud område',
          beskrivelse: 'Se om ting ser godt ud i denne bbox.',
          bbox: [562000, 6322000, 564000, 6324000],
        },
      ],
      afsluttet: [

      ],
    },
    popup: {
      x: 0,
      y: 0,
      visible: false,
      loading: false,
      vejkode: '',
      kommuneKode: 0,
      geoDkId: 0,
      vejmidteType: '',
      vejnavn: '',
      postnummer: '',
    },
  },
  mutations: {
    // commit
    setMap (state, map) {
      state.map = map;
    },
    setCenter (state, center) {
      state.center = center;
    },
    setZoom (state, zoom) {
      state.zoom = zoom;
    },
    setToken (state, token) {
      state.token = token;
    },
    addGeoDkObjekt (state, obj) {
      const vejkode = obj.get('vejkode');
      if (vejkode && state.fetchedVejkoder[vejkode]) {
        obj = decorateGeoDkObjektWithAdressering(obj, state.fetchedVejkoder[vejkode]);
      }
      state.geoDkObjekter = [...state.geoDkObjekter, obj];
    },
    removeGeoDkObjekt (state, objekt) {
      state.geoDkObjekter = state.geoDkObjekter.filter(obj => obj !== objekt);
    },
    removeAllGeoDkObjekter (state) {
      state.geoDkObjekter = [];
    },
    toggleVisibleLayer () {},
    highlightSelectedGeodk () {}, // payload: { geoDkId, scrollTo }
    addFetchedVejkoder (state, vejkode) {
      if (vejkode) {
        state.fetchedVejkoder = { ...state.fetchedVejkoder, [vejkode.kode]: vejkode };
      }
    },
    addVejkodeAdressePunkter (state, vejkodeAdressePunkter) {
      state.vejkodeAdressePunkter = {
        ...state.vejkodeAdressePunkter,
        [vejkodeAdressePunkter.kode]: {
          adressepunkter: vejkodeAdressePunkter.adressepunkter,
          vejpunktlinje: vejkodeAdressePunkter.vejpunktlinje,
        },
      };
    },
    updateUser (state, user) {
      state.user = user;
    },
    updateKommune (state, kommunekode) {
      if (state.kommune.kode !== kommunekode) {
        state.useKommuneBBox = true;
        DawaApi.getKommune(kommunekode)
          .then(response => {
            state.kommune = {
              kode: kommunekode,
              navn: response.navn,
            };
          });
      }
    },
    setLoading (state, loading) {
      state.loading = loading;
    },
    setUseKommuneBBox (state, useBBox) {
      state.useKommuneBBox = useBBox;
    },
    updatePopup (state, props) {
      state.popup = { ...state.popup, ...props };
    },
  },
  actions: {
    // dispatch
    getGeoDkObjektByCoordinate (context, coordinate) {
      const { state } = context;
      if (!state.user) {
        console.log('user not logged in');
        return;
      }
      var bbox = [];
      var buffer = state.map.getView().getResolution() * 5;
      bbox[0] = coordinate[0] - buffer;
      bbox[1] = coordinate[1] - buffer;
      bbox[2] = coordinate[0] + buffer;
      bbox[3] = coordinate[1] + buffer;
      GeoDkApi.getGeoDkObjektByBbox(bbox, state.user.token)
        .then(f => {
          if (!f) {
            return;
          }
          if (state.geoDkObjekter.filter(g => g.get('geoDkId') === f.get('geoDkId')).length) {
            context.commit('removeGeoDkObjekt', f);
          } else {
            if (f.get('vejkode') && !state.fetchedVejkoder[f.get('vejkode')]) {
              context.dispatch('getVejkodeAdressering', { kommunekode: f.get('kommunekode'), vejkode: f.get('vejkode'), geoDkObjekt: f })
                .then(adressering => {
                  decorateGeoDkObjektWithAdressering(f, adressering);
                  context.commit('addGeoDkObjekt', f);
                })
                .catch(() => {
                  context.commit('addGeoDkObjekt', f);
                });
            } else {
              context.commit('addGeoDkObjekt', f);
            }
          }
        })
        .catch(error => {
          throw error;
        });
    },
    getGeoDkObjektById (context, payload) {
      const { state } = context;
      const { geodkid, makeSureInMap = false } = payload;
      GeoDkApi.getGeoDkObjektById(geodkid, state.user.token)
        .then(f => {
          if (state.geoDkObjekter.filter(g => g.get('geoDkId') === f.get('geoDkId')).length) {
            context.commit('removeGeoDkObjekt', f);
          } else {
            if (f.get('vejkode') && !state.fetchedVejkoder[f.get('vejkode')]) {
              context.dispatch('getVejkodeAdressering', { kommunekode: f.get('kommunekode'), vejkode: f.get('vejkode'), geoDkObjekt: f })
                .then(adressering => {
                  decorateGeoDkObjektWithAdressering(f, adressering);
                  context.commit('addGeoDkObjekt', f);
                  if (makeSureInMap) {
                    fitToGeoDkLayerExtent(state.map, geodkVectorSelected);
                  }
                });
            } else {
              context.commit('addGeoDkObjekt', f);
              if (makeSureInMap) {
                fitToGeoDkLayerExtent(state.map, geodkVectorSelected);
              }
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getVejkodeAdressering (context, payload) {
      return new Promise((resolve, reject) => {
        const { kommunekode, vejkode, refresh } = payload;
        if (!vejkode) {
          reject(new Error('Manglende vejkode'));
        }
        const existingVejkode = context.state.fetchedVejkoder[vejkode.padStart(4, '0')];
        if (existingVejkode && !refresh) {
          resolve(existingVejkode);
        } else {
          DawaApi.getAdresseringForKommunenummerVejkode(kommunekode, vejkode)
            .then(adressering => {
              context.commit('addFetchedVejkoder', adressering);
              resolve(adressering);
            })
            .catch((error) => { // error => {
              reject(error);
            });
        }
      });
    },
    getVejkodeAdressePunkter (context, payload) {
      return new Promise((resolve, reject) => {
        const { kommunekode, vejkode } = payload;
        const existingAdressePunkt = context.state.vejkodeAdressePunkter[vejkode];
        if (existingAdressePunkt) {
          resolve(existingAdressePunkt);
        } else {
          if (!vejkode) {
            reject(new Error('Missing vejkode'));
          } else {
            DawaApi.getAdressePunkterForKommunenummerVejkode(kommunekode, vejkode)
              .then(response => {
                const adressepunkter = response.map((adresse) => {
                  return new Feature({
                    geometry: new Point(adresse.adgangspunkt.koordinater),
                    husnr: adresse.husnr,
                    tekstretning: adresse.adgangspunkt.tekstretning,
                  });
                });
                const vejpunktlinje = response.map((adresse) => {
                  return new Feature(
                    new LineString([adresse.adgangspunkt.koordinater, adresse.vejpunkt.koordinater]),
                  );
                });
                const vejkodeAdressePunkter = {
                  kode: vejkode,
                  adressepunkter,
                  vejpunktlinje,
                };
                context.commit('addVejkodeAdressePunkter', vejkodeAdressePunkter);
                resolve(vejkodeAdressePunkter);
              })
              .catch(error => {
                reject(error);
              });
          }
        }
      });
    },
  },
  getters: {
    mapPosition: state => {
      const { center, zoom } = state;
      return {
        center,
        zoom,
      };
    },
  },
});
if (window.Cypress) {
  window.__store__ = store;
}

function decorateGeoDkObjektWithAdressering (geoDkObjekt, vejkodeMedAdressering) {
  const adressering = getAdresseringFromVejkodeObjekt(vejkodeMedAdressering);
  geoDkObjekt.set('adressering', adressering);
  return geoDkObjekt;
}

export default store;
